import pimg1 from '../images/project/project-1/1.jpg'
import pimg2 from '../images/project/project-1/2.jpg'
import pimg3 from '../images/project/project-1/3.jpg'
import pimg4 from '../images/project/project-1/4.jpg'
import pimg5 from '../images/project/project-1/5.jpg'
import pimg6 from '../images/project/project-1/6.jpg'
import pimg7 from '../images/project/project-1/7.jpg'
import pimg8 from '../images/project/project-1/8.jpg'

import pimg10 from '../images/project/project-1/10.jpg'
import pimg11 from '../images/project/project-1/11.jpg'
import pimg12 from '../images/project/project-1/12.jpg'
import pimg9 from '../images/project/project-1/9.jpg'


const Projects = [
  
  {
    id: '1',
    title: 'Modern Design Villa',
    subtitle: 'Design | Construction',
    slug: 'Modern-House',
    pimg: pimg1,
    // sing: Sing1,
    subTitle: 'e',
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '2',
    title: 'Interior Design',
    subtitle: 'Design | Construction',
    slug: 'Modern-House',
    pimg: pimg2,
    subTitle: 'i',
    // sing: Sing2,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '3',
    title: 'Organic Design',
    subtitle: 'Design | Construction',
    slug: 'Interior-Design',
    pimg: pimg3,
    subTitle: 'e',
    // sing: Sing3,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '4',
    title: 'Neoclassic Design',
    subtitle: 'Design | Construction',
    slug: 'Interior-Design',
    pimg: pimg4,
    subTitle: 'e',
    // sing: Sing4,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '5',
    title: 'Minimalistic Design',
    subtitle: 'Design | Construction',
    slug: 'Modern-House2',
    pimg: pimg5,
    subTitle: 'i',
    // sing: Sing5,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '6',
    title: 'Kiosk Design',
    subtitle: 'Design | Construction',
    slug: 'Art-Museum',
    pimg: pimg6,
    subTitle: 'e',
    // sing: Sing6,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '7',
    title: 'Interior Design',
    subtitle: 'Design | Construction',
    slug: 'Farm-House',
    pimg: pimg7,
    subTitle: 'i',
    // sing: Sing7,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '8',
    title: 'Interior Design',
    subtitle: 'Design | Construction',
    slug: 'Dream-House',
    pimg: pimg8,
    subTitle: 'i',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '9',
    title: 'Interior Design',
    subtitle: 'Design | Construction',
    slug: 'Farm-House',
    pimg: pimg9,
    subTitle: 'i',
    // sing: Sing7,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '10',
    title: 'Interior Design',
    subtitle: 'Design | Construction',
    slug: 'Dream-House',
    pimg: pimg10,
    subTitle: 'i',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },

  {
    id: '11',
    title: 'Villa',
    subtitle: 'Design | Construction',
    slug: 'Farm-House',
    pimg: pimg11,
    subTitle: 'e',
    // sing: Sing7,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '12',
    title: 'Green Land City',
    subtitle: 'Design | Construction',
    slug: 'Dream-House',
    pimg: pimg12,
    subTitle: 'e',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },
  // {
  //   id: '13',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg13,
  //   subTitle: 'i',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '14',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg14,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '15',
  //   title: 'Private Guest Hall',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg15,
  //   subTitle: 'i',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '16',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg16,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '17',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg17,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '18',
  //   title: 'Modern Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg18,
  //   subTitle: 'e',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  
  
  // {
  //   id: '20',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg20,
  //   subTitle: 'c',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '21',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg21,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '22',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg22,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '23',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg23,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '24',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg24,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '25',
  //   title: 'Kitchen Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg25,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '26',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg26,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },

  // {
  //   id: '27',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg31,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '30',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg32,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '31',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg33,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '32',
  //   title: 'Mass Village',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg34,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '33',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg35,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '34',
  //   title: 'Mass Village',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg36,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  
  // {
  //   id: '37',
  //   title: 'Green Land City Roads',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg39,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '38',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg40,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '39',
  //   title: '‌Hospital',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg41,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '40',
  //   title: 'Green Land City Roads',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg42,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '41',
  //   title: 'Nanakali Hospital',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg43,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '42',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg44,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '43',
  //   title: 'Mihrabani Hospital',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg45,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '44',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg46,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  
  // {
  //   id: '47',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg49,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '48',
  //   title: 'Green Land City Roads',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg50,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '49',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg51,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },

  // {
  //   id: '50',
  //   title: 'Basra Courthouse Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg52,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '51',
  //   title: 'Basra Courthouse Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg53,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '52',
  //   title: 'Basra Courthouse Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg54,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '53',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg55,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '54',
  //   title: 'House Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg56,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '55',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg57,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '56',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg58,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '57',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg59,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '58',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg60,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '59',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg61,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '60',
  //   title: 'Green Land City',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg62,
  //   subTitle: 'e',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '61',
  //   title: 'Green Land City',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg63,
  //   subTitle: 'e',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '62',
  //   title: 'Green Land City',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg64,
  //   subTitle: 'e',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },

  // {
  //   id: '63',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg65,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '64',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg66,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '65',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg67,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '66',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg68,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '67',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg69,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '68',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg70,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '69',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg71,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '70',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg72,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '71',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg73,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '72',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg74,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '73',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg75,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '74',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg76,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '75',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg77,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '76',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg78,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '77',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg79,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '78',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg80,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '79',
  //   title: 'Private Meeting Hall',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg81,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '80',
  //   title: 'Private Meeting Hall',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg83,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '81',
  //   title: 'Private Meeting Hall',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg84,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '82',
  //   title: 'Private Meeting Hall',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg85,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '83',
  //   title: 'Basra Private Office Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg86,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '84',
  //   title: 'Basra Private Office Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg87,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '85',
  //   title: 'Basra Private Office Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg88,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '86',
  //   title: 'Basra Private Office Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg89,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '87',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg90,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '88',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg82,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
]
export default Projects
